import moment from 'moment'
moment.locale('pt-br')

const methods = {
  format: (date) => {
    if (date) return moment(date).format('L') // DD/MM/AAAA
    else return undefined
  },
  formatDateHour: (date) => {
    return moment(date).format('DD/MM/YYYY HH:mm:ss') // DD/MM/AAAA
  },
  formatStyle: (date, style) => {
    return moment(date).format(style)
  },
  APIFormat: (date) => {
    return moment(date).format('YYYY-MM-DD')
  },
  daysDiff: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return Math.abs(startDate.diff(endDate, 'days', true))
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return Math.abs(startDate.diff(endDate, 'days', true))
    }
  },
  daysDiffInteger: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return Math.abs(startDate.diff(endDate, 'days'))
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return Math.abs(startDate.diff(endDate, 'days'))
    }
  },
  daysDiffSigned: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return startDate.diff(endDate, 'days', true)
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return startDate.diff(endDate, 'days', true)
    }
  },
  daysDiffIntegerSigned: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return startDate.diff(endDate, 'days')
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return startDate.diff(endDate, 'days')
    }
  },
  subtract: (date, quantity, type) => {
    return moment(date).subtract(quantity, type).format()
  },
  add: (date, quantity, type) => {
    return moment(date).add(quantity, type).format()
  },
  now: () => {
    return moment(new Date()).format()
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/dates.js